// import { useEffect, useState } from "react";
// import config  from "../config";

// import sendData from "../common/sendData";
// import { useKeycloak } from "@react-keycloak/web";

// const ApiURL = `${config.app.apiBaseUrl}chatbots/v1/Chats`;

// function usePostChat(triggered, userId){
//   const [returnValue, setReturnValue] = useState({});
//   const {keycloak} = useKeycloak();

//   useEffect(() => {
//     async function init() {
//       if (!triggered) return;
//       let bearerToken = keycloak.token;

//       let chatData = {
//         "chatbotAgentId": 1,
//         "userId": userId
//       }

//       let response = await sendData(bearerToken, ApiURL, "POST", chatData, false);
//       setReturnValue(response);
//     }
//     init();
//   }, [triggered])

//   return returnValue;
// }

// export default usePostChat;

import config from "../config";
import sendData from "../common/sendData";
import { useKeycloak } from "@react-keycloak/web";

const ApiURL = `${config.app.apiBaseUrl}chatbots/v1/Chats`;

function usePostChat() {
  const { keycloak } = useKeycloak();

  async function postChat(userId) {
    let bearerToken = keycloak.token;

    let chatData = {
      chatbotAgentId: 1,
      userId: userId,
    };

    let response = await sendData(bearerToken, ApiURL, "POST", chatData, false);
    let chatId = await response.text(); // 👈 Extracts the body correctly

    return { id: chatId };
  }

  return postChat;
}

export default usePostChat;